import { tv } from "../../variants/tv.js";
const attributeEmphasisVariants = {
    regular: {},
    bold: {
        iconSlot: 'text-neutral-1',
        textSlot: 'text-neutral-1'
    }
};
const attributeEmphases = Object.keys(attributeEmphasisVariants);
const attributeVariants = tv({
    slots: {
        root: 'flex flex-row items-center gap-1',
        iconSlot: '',
        imageIconWrapperSlot: 'relative flex flex-col items-center justify-center',
        imageSlot: '',
        textSlot: 'text-center',
        textWrapperSlot: 'flex items-center gap-2'
    },
    variants: {
        emphasis: attributeEmphasisVariants,
        hasIcon: {
            true: {}
        },
        isActionable: {
            true: {
                root: 'group/attribute group hover:cursor-pointer',
                textSlot: 'group-hover/attribute:underline'
            }
        },
        isVertical: {
            true: {
                root: 'flex-col'
            },
            false: {
                root: 'flex-row',
                textSlot: 'text-left'
            }
        },
        showImage: {
            true: {
                iconSlot: 'absolute block w-full text-center text-neutral-1'
            }
        },
        size: {
            sm: {},
            md: {}
        },
        truncate: {
            true: {
                root: 'min-w-0',
                textSlot: 'truncate',
                textWrapperSlot: 'min-w-0'
            }
        }
    },
    compoundVariants: [
        {
            isVertical: true,
            size: 'sm',
            class: {
                imageIconWrapperSlot: 'h-8 w-8'
            }
        },
        {
            isVertical: true,
            size: 'md',
            class: {
                imageIconWrapperSlot: 'h-10 w-10'
            }
        },
        {
            isVertical: true,
            showImage: true,
            class: {
                imageIconWrapperSlot: 'w-10'
            }
        },
        {
            hasIcon: true,
            isVertical: true,
            class: {
                imageSlot: 'brightness-[70%]'
            }
        },
        {
            isVertical: true,
            truncate: true,
            class: {
                root: 'w-full items-center',
                textWrapperSlot: 'w-full max-w-full justify-center'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        hasIcon: false,
        isVertical: false,
        showImage: false,
        size: 'md'
    }
});
export { attributeEmphases, attributeEmphasisVariants, attributeVariants };
